import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { cacheDom } from "../../utils/QuerySelectors.js"
import { setOpen, setCountry, setAddress1Error, setAddress2Error, setFirstNameError, setLastNameError, setCityError, setZipcodeError, setPhoneError, setFilled } from '../store/addressSlice'

const dom = {}
const qs = {
  list: 'data-addresses-list',
  add: 'data-address-add',
  countryOptions: 'data-country-options',
  form: 'data-address-form-details',
}
const qsAll = {
}

const AddressForm = () => {
  const dispatch = useDispatch()
  const { address, open, address1Error, address2Error, firstNameError, lastNameError, cityError, zipcodeError, phoneError, filled } = useSelector((state) => state.address)
  cacheDom(dom, qs, qsAll)
  useEffect(() => {
    dom.list.classList.toggle('hidden', open)
    dom.add.classList.toggle('hidden', open)
  }, [open])
  
  const checkAddress = (str, addressType=1) => {
    const specialCharacters = ['~', '`', '!', '@', '$', '%', '^', '(', ')', '+', '[', ']', ':', ';', '|']
    let valid = true
    specialCharacters.forEach(s => {
      if(str.includes(s)) valid = false
    })
    if(addressType == 1) {
      dispatch(setAddress1Error(!valid))
    } else {
      dispatch(setAddress2Error(!valid))
    }
  }

  const updateFilledState = () => {
    const firstName = dom.form.querySelector('#AddressFirstName').value?.trim()
    const lastName = dom.form.querySelector('#AddressLastName').value?.trim()
    const address1 = dom.form.querySelector('#AddressAddress1').value?.trim()
    const city = dom.form.querySelector('#AddressCity').value?.trim()
    const zipcode = dom.form.querySelector('#AddressZip').value?.trim()
    const phone = dom.form.querySelector('#AddressPhone').value?.trim()
    dispatch(setFilled(!!firstName && !!lastName && !!address1 && !!city && !!zipcode && !!phone))
  }

  console.log(address)

  return (
    <form className={`flex flex-col w-full gap-x-3.75 gap-y-11 pb-12.5 bg-back ${open ? '' : 'hidden'}`} method='post' action={`/account/addresses${address && address.id ? '/' +  address.id : ''}`} acceptCharset='UTF-8' data-address-form-details>
      <input type="hidden" name="form_type" value="customer_address" />
      <input type="hidden" name="utf8" value="✓" />

      <div className="flex items-center justify-between mb-5">
        <h1 className="text-sm">
          {
            address && address.id ? window.accountStrings.addresses.editAddress : window.accountStrings.addresses.addNew
          }
        </h1>
        <div className="normal-case text-xs">
          {Shopify.theme.schema_name} - {window.accountStrings.title} - {window.accountStrings.addresses.title} - { address && address.id ? window.accountStrings.addresses.editAddress : window.accountStrings.addresses.addNew }
        </div>
      </div>
      
      { (address1Error || address2Error) && <div className='normal-case text-tb-red mb-3.75 flex items-center gap-2.5'>
          <span className='w-1.5 h-1.5 rounded-full bg-tb-red'></span>
          {window.accountStrings.addresses.pleaseInclude}
        </div> 
      }

      {/* <div className='select-wrap'>
        <div className='text-fourth-grey normal-case mb-2.5'>Address Type *</div>
        <select data-address-type>
          <option>Address Type</option>
          <option value={'Home Address'}>Home Address</option>
          <option value={'Work Address'}>Work Address</option>
        </select>
      </div> */}

      <div className='grid grid-cols-1 lg:grid-cols-2 gap-x-3.75 gap-y-11'>
        <div className={`input-wrap ${window.userCountrySelection == 'KR' || window.userCountrySelection == 'JP' ? 'order-1' : ''}`}>
          <input
            type="text"
            className='!bg-transparent !rounded-none'
            id="AddressFirstName"
            name="address[first_name]"
            defaultValue={address && address.first_name}
            autoComplete="given-name"
            placeholder={window.accountStrings.addresses.firstName}
            required
            onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
            onBlur={e => {
              e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
            }}
            onInput={e => {
              dispatch(setFirstNameError(false))
              updateFilledState()
            }}
          />
          <label htmlFor="AddressFirstName">{window.accountStrings.addresses.firstName}</label>
        </div>
        <div className="input-wrap ">
          <input
            type="text"
            id="AddressLastName"
            className='!bg-transparent !rounded-none'
            name="address[last_name]"
            defaultValue={address && address.last_name}
            autoComplete="family-name"
            placeholder={window.accountStrings.addresses.lastName}
            required
            onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
            onBlur={e => {
              e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
            }}
            onInput={e => {
              dispatch(setLastNameError(false))
              updateFilledState()
            }}
          />
          <label htmlFor="AddressLastName">{window.accountStrings.addresses.lastName}</label>
        </div>
      </div>

      <div className='select-wrap'>
        <label htmlFor="AddressCountry">{window.accountStrings.addresses.country}</label>
        <select
          id="AddressCountry"
          name="address[country]"
          autoComplete="country"
          required
          value={address?.country}
          onChange={(e) => dispatch(setCountry(e.target.value))}
          dangerouslySetInnerHTML={{ __html: dom.countryOptions.innerHTML}}
        >
        </select>
      </div>
      
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-x-3.75 gap-y-11'>
        <div className={`input-wrap ${address1Error ? 'input-error' : ''}`}>
          <input
            type="text"
            className='!bg-transparent !rounded-none'
            id="AddressAddress1"
            name="address[address1]"
            defaultValue={address && address.address1}
            autoComplete="address-line1"
            placeholder={window.accountStrings.addresses.address1}
            required
            onInput={e => { 
              checkAddress(e.target.value)
              updateFilledState() 
            }}
            onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
            onBlur={e => {
              e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
            }}
          />
          <label htmlFor="AddressAddress1">{window.accountStrings.addresses.address1}</label>
          { address1Error && 
            <span className='absolute bottom-full mb-2.5 right-0 normal-case text-tb-red'>{window.accountStrings.addresses.invalidAddress}</span> 
          }
        </div>
        <div className={`input-wrap ${address2Error ? 'input-error' : ''}`}>
          <input
            type="text"
            className='!bg-transparent !rounded-none'
            id="AddressAddress2"
            name="address[address2]"
            defaultValue={address && address.address2}
            autoComplete="address-line2"
            placeholder={window.accountStrings.addresses.address2}
            onInput={e => { 
              checkAddress(e.target.value, 2)
              updateFilledState() 
            }}
            onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
            onBlur={e => {
              e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
            }}
          />
          <label htmlFor="AddressAddress2">{window.accountStrings.addresses.address2}</label>
          { address2Error && 
            <span className='absolute bottom-full mb-2.5 right-0 normal-case text-tb-red'>{window.accountStrings.addresses.invalidAddress}</span> 
          }
        </div>
      </div>
      
      <div className={`grid gap-x-3.75 gap-y-11 grid-cols-1 ${address && address.country && JSON.parse(dom.countryOptions.querySelector(`[value="${address.country}"]`).dataset.provinces).length > 0 ? 'lg:grid-cols-2' : ''}`}>
        <div className="input-wrap ">
          <input
            type="text"
            className='!bg-transparent !rounded-none'
            id="AddressCity"
            name="address[city]"
            defaultValue={address && address.city}
            autoComplete="address-level2"
            placeholder={window.accountStrings.addresses.city}
            required
            onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
            onBlur={e => {
              e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
            }}
            onInput={e => {
              dispatch(setCityError(false))
              updateFilledState()
            }}
          />
          <label htmlFor="AddressCity">{window.accountStrings.addresses.city}</label>
        </div>
        {
          address && address.country && JSON.parse(dom.countryOptions.querySelector(`[value="${address.country}"]`).dataset.provinces).length > 0 &&
          <div className='select-wrap '>
            <label className='mb-3 block' htmlFor="AddressProvince">{window.accountStrings.addresses.state}</label>
            <select
              id="AddressProvince"
              name="address[province]"
              defaultValue={address?.province}
              autoComplete="address-level1"
              required
            >
              {
                address && address.country && JSON.parse(dom.countryOptions.querySelector(`[value="${address.country}"]`).dataset.provinces).map((province, index) =>
                  <option value={province[1]} key={`province-${index}`}>{province[0]}</option>
                )
              }
            </select>
          </div>
        }
      </div>

      <div className='grid grid-cols-1 lg:grid-cols-2 gap-x-3.75 gap-y-11'>
        <div className="input-wrap ">
          <input
            type="text"
            className='!bg-transparent !rounded-none'
            id="AddressZip"
            name="address[zip]"
            defaultValue={address && address.zip}
            autoCapitalize="characters"
            autoComplete="postal-code"
            placeholder="Zip/Postal Code *"
            required
            onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
            onBlur={e => {
              e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
            }}
            onInput={e => {
              dispatch(setZipcodeError(false))
              updateFilledState()
            }}
          />
          <label htmlFor="AddressZip">{window.accountStrings.addresses.zip}</label>
        </div>
        <div className="input-wrap ">
          <input
            type="tel"
            className='!bg-transparent !rounded-none'
            id="AddressPhone"
            name="address[phone]"
            defaultValue={address && address.phone}
            autoComplete="tel"
            placeholder={window.accountStrings.addresses.phone}
            onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
            onBlur={e => {
              e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
            }}
            onInput={e => {
              dispatch(setPhoneError(false))
              updateFilledState()
            }}
          />
          <label htmlFor="AddressPhone">{window.accountStrings.addresses.phone}</label>
        </div>
      </div>
      
      {/* <div className='grid grid-cols-1 lg:grid-cols-2 gap-x-3.75 gap-y-11 mb-3.75'>
        <label className='checkbox-wrapper'>
          <input type='radio' name='preferOption' id='setShippingAddress' value='Shipping' />
          Prefered Shipping Address
        </label>
        <label className='checkbox-wrapper'>
          <input type='radio' name='preferOption' id='setBillingAddress' value='Billing' />
          Prefered Billing Address
        </label>
      </div> */}
      <div className=''>
        <label
          htmlFor="address_default"
          className="checkbox-wrapper w-full"
        >
          <input type="checkbox" id="address_default" name="address[default]" value="1" defaultChecked={address && address.default == true} />
          <span className="checkbox-text justify-center !text-fore">
            {window.accountStrings.addresses.setDefault}
          </span>
        </label>
      </div>

      <div className='grid grid-cols-1 lg:grid-cols-2 gap-x-3.75 gap-y-11'>
        <button type="reset" 
          className='button button--secondary w-full'
          onClick={() => dispatch(setOpen(false))}
        >
          {window.accountStrings.addresses.cancel}
        </button>
        <button className={`button w-full relative ${address1Error || firstNameError || lastNameError || cityError || zipcodeError || phoneError || !filled ? '' : 'button--primary'}`}
          onClick={(e) => e.target.classList.add('button--loading')}
          disabled={address1Error || firstNameError || lastNameError || cityError || zipcodeError || phoneError || !filled}
        >
          {window.accountStrings.addresses.save}
          <div className="button--loading__pane">
            <span className="button--loading__dot"></span>
            <span className="button--loading__dot"></span>
            <span className="button--loading__dot"></span>
          </div>
        </button>
      </div>
      
      { address && address.id ? <input type="hidden" name="_method" value="put" /> : null }
    </form>
  )
}

export default AddressForm